export default __webpack_public_path__ + "static/media/chevron_leftHealthgenom.f46344db.svg";